import React from 'react';
import { FormFeedback, FormGroup, Label, Input } from 'reactstrap';
import $ from 'jquery';
import PropTypes from 'prop-types';

class ValidatedTextBox extends React.Component {
    constructor(props) {
        super(props);

        this.validate = this.validate.bind(this);
        this.onchange = this.onchange.bind(this);

        this.state = {
            valid: false,
            errorMessage: "",
            inputCls: 'is-invalid ' + this.props.isEnabled ? "" : "disabled",
            value: this.props.value
        };

        //this.setState({ valid: false, errorMessage : "Please enter a valid value."})
    }

    componentDidUpdate(prevProps) {
        if (this.props.submitted && !prevProps.submitted) {
            const input = document.getElementById(this.props.id);
            if (input) this.validate(input.value, input.placeholder);
        }
    }

    validate(inputValue, defaultValue) {
            if (inputValue.includes('!')) {
                if(this.props.id === 'documentType'){
                    this.setState({ inputCls: 'is-invalid', valid: false, errorMessage: "Document Type cannot contain an exclamation mark (!)." })
                    return false;
                }
            }
            else if (this.props.mandatory) {
            if (inputValue) {
                this.setState({ inputCls: 'is-valid', valid: false, errorMessage: "" })
                return true;
            }

            else if (defaultValue) {
                this.setState({ inputCls: 'is-valid', valid: false, errorMessage: "" })
                return true;
            }
            else {
                this.setState({ inputCls: 'is-invalid', valid: true, errorMessage: "Please enter a valid value" })
                return false;
            }
        }
        else {
            this.setState({ inputCls: 'is-valid', valid: false, errorMessage: "" })
            return true;
        }
    }

    onchange(e) {
        //console.log('change');
        //validate the selection 
        if (this.validate(e.target.value, e.target.placeholder)) {
            //ripple up the change 
            this.props.onChange(true, e);
        }
        else {
            this.props.onChange(false, e);
        }
    }

    render() {
        var style = {};
        style.display = 'none';
        const input = [];
        var type = 'text';

        if (this.props.password)
            type = 'password'
        if (this.props.isEnabled) {
            input.push(<Input id={this.props.id} type={type} className={this.state.inputCls} onChange={this.onchange} onBlur={this.onchange} defaultValue={this.props.value}></Input>);
        }
        else {
            input.push(<Input id={this.props.id} type={type} disabled defaultValue={this.props.value}></Input>);
        }

        return (<FormGroup>
            <Label className="s-field-title s-anchored">{this.props.labelText}</Label>
            {input}
            <FormFeedback style={{ fontSize: '14px' }} visible={this.state.valid}>{this.state.errorMessage}</FormFeedback>
        </FormGroup>);
    }
};

export default ValidatedTextBox; 